import React from "react";
import { Link } from "react-router-dom";

interface CashState {
    loginYn: string;
    nickname: string;
    rcmnCd: string;
    gameMnyNm: string;
    totMny: number;
}

interface MyCashSectionProps {
    myCashState: CashState | null;
    loginInfoState: any;
    firstLetter: string;
    isBrickTooltipOpen: boolean;
    onToggleBrickInfo: () => void;
    langData: any;
    gameSvcCd: string;
    shopKindCd: string;
}

const MyCashSection = ({
    myCashState,
    loginInfoState,
    firstLetter,
    isBrickTooltipOpen,
    onToggleBrickInfo,
    langData,
    gameSvcCd,
    shopKindCd,
}: MyCashSectionProps) => {
    const parsedTotMny = Number(String(myCashState?.totMny ?? 0).replace(/,/g, ""));
    const formattedTotMny = Number.isFinite(parsedTotMny)
        ? parsedTotMny.toLocaleString()
        : String(myCashState?.totMny ?? "0");

    if (myCashState && myCashState.loginYn === "Y") {
        return (
            <div className="myCashWrap myCashHdr">
                <div className="shopContainer">
                    <div className="brickInfoTitlWrap">
                        {loginInfoState?.provider && loginInfoState.provider !== "MGP" && loginInfoState?.ssoImgPUrl ?
                            <div className={`shopSsoLoginInfoCircle ${loginInfoState.provider}Icon`}>
                                <img src={loginInfoState.ssoImgPUrl} alt="" />
                            </div>
                            :
                            <div className="shopLoginInfoCircle">
                                <h1>{firstLetter}</h1>
                            </div>
                        }
                        <p>{myCashState.nickname}<span>#{myCashState.rcmnCd}</span></p>
                    </div>
                    <div className="brickInfoWrap">
                        <div>
                            <img src={process.env.PUBLIC_URL + "/images/Shop/brickIcon.png"} alt="" />
                            <h2>My {myCashState.gameMnyNm}</h2>
                            <div className="brickInfoTooltipWrap">
                                <button className="brickInfo" aria-label={langData?.GAME_SHOP_MY_BRICK_INFO_ARIA_00 || "My 브릭 안내"} onClick={onToggleBrickInfo}>
                                    <img src={process.env.PUBLIC_URL + "/images/Shop/infoIcon.png"} alt="" />
                                </button>
                                <div className={`brickInfoTooltip ${isBrickTooltipOpen ? "open" : ""}`}>
                                    {langData?.GAME_SHOP_MY_BRICK_INFO_DESC_00 || "베어브릭히어로즈의 주요 상품을 구매할 수 있는 재화입니다"}
                                </div>
                            </div>
                        </div>
                        <div>
                            <p style={{ fontSize: "14px" }}>{formattedTotMny}</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="myCashWrap myCashHdr">
            <div className="shopContainer">
                <p>{langData?.GAME_SHOP_LOGIN_DESC_00||"로그인을 하시면 나의 베어브릭히어로즈브릭 정보를 확인할 수 있습니다."}</p>
                <Link className="buttonBgB" to={`/Login?referrer=${encodeURIComponent(`/GamePage/ShopLst?gameSvcCd=${gameSvcCd}&ctntKindCd=${shopKindCd}`)}`}>
                    <p>{langData?.COMM_MAIN_LOGIN_MAIN_BTN_00 || "로그인"}</p>
                </Link>
            </div>
        </div>
    );
};

export default MyCashSection;